import ActionType from './ActionType';
import { MikeSnackbarType } from '../components/mike-snackbar';

export type MessaType = 'success' | 'warning' | 'error' | 'info'; // | 'alert';

export const initialMessageState: MessageState = {
  showMessage: false,
  message: '',
  messagetype: 'info',
};

export interface MessageState {
  showMessage: boolean;
  message: string;
  messagetype: MessaType;
}

export type Action =
  | { type: ActionType.SET_SHOW_MESSAGE; show: boolean }
  | { type: ActionType.SET_MESSAGE; message: string }
  | { type: ActionType.SET_MESSAGE_TYPE; messagetype: MessaType };

export const messageReducer = (state: MessageState, action: Action) => {
  switch (action.type) {
    case ActionType.SET_SHOW_MESSAGE:
      return {
        ...state,
        showMessage: action.show,
      };

    case ActionType.SET_MESSAGE:
      return {
        ...state,
        message: action.message,
      };

    case ActionType.SET_MESSAGE_TYPE:
      return {
        ...state,
        messagetype: action.messagetype,
      };

    default:
      return state;
  }
};

// TODO: Ideally re-write the messageReducer to fit the new format
// and to work with only one dispatch call containing all arguments
// iso call it 2-3 times as we do now.
export const messaType2MikeSnackbarType = (inType: MessaType): MikeSnackbarType => {
  switch (inType) {
    case 'success':
      return 'success';
    case 'error':
      return 'error';
    case 'warning':
      return 'error';
    case 'info':
      return 'regular';
    default:
      return 'regular';
  }
};
